import React from "react";
import { useNavigate } from "react-router-dom";

export default function Fifth() {
  const navigate = useNavigate();
  return (
    <section className="bg-homeSec5 bg-[#13476A] bg-cover bg-no-repeat sm:py-20 py-12">
      <section className="sm:w-4/5 w-11/12 mx-auto flex flex-col sm:items-start gap-y-5">
        <h1 className="font-bold lg:text-6xl sm:text-5xl text-4xl text-white xl:w-2/3 lg:w-4/5">
        Do you need to ship something from China?
        </h1>
        <div>
          <button
          onClick={()=>navigate("/login")}
            className="font-medium text-xl bg-themeRed text-white px-5 py-2 rounded border border-themeRed
                    hover:bg-white hover:border-white hover:text-themeRed"
          >
            Get Started
          </button>
        </div>
      </section>
    </section>
  );
}
